import { VimeoFrame } from "../../utils/fw"

export default {
	background: "https://assets.swoogo.com/uploads/full/1468014-618d562fac0ad.jpg",
	links: [
		{
			label: "To Lobby",
			href: "/lobby",
			width: "14.5%",
			height: "5.4%",
			left: "42.3%",
			top: "2.9%",
		},
		{
			label: "Inspire Evolve Brochure",
			href: "https://resources.quadient.com/m/22ee94ba25ca1046/original/Inspire-Evolve-Brochure.pdf",
			isExternal: true,
			target: "_blank",
			width: "5.3%",
			height: "11.6%",
			left: "7.7%",
			top: "25.7%",
		},
		{
			label: "Inspire Evolve Datasheet",
			href: "https://resources.quadient.com/m/1fd603802eeccb87/original/Datasheet-Inspire-Evolve.pdf",
			isExternal: true,
			target: "_blank",
			width: "4.7%",
			height: "10.7%",
			left: "13.7%",
			top: "27.2%",
		},
		{
			label: "Inspire Flex Brochure",
			href: "https://resources.quadient.com/m/3002685793800629/original/Inspire-Flex-Brochure.pdf",
			isExternal: true,
			target: "_blank",
			width: "4.6%",
			height: "10.9%",
			left: "19.0%",
			top: "27.8%",
		},
		{
			label: "Inspire Journey Brochure",
			href: "https://resources.quadient.com/m/40d372c848c75a19/original/Inspire-Journey-Brochure.pdf",
			isExternal: true,
			target: "_blank",
			width: "5.7%",
			height: "12.5%",
			left: "10.1%",
			top: "38%",
		},
		{
			label: "Inspire Journey Datasheet",
			href: "https://resources.quadient.com/m/e06c844b40a9a54/original/Inspire-Journey-Datasheet.pdf",
			isExternal: true,
			target: "_blank",
			width: "4.8%",
			height: "11.4%",
			left: "16.9%",
			top: "39.4%",
		},
		{
			label: "Spark MATRIX™ for Customer Communications Management, 2021",
			href: "https://resources.quadient.com/m/34f770432f02e903/original/SPARK-Matrix_Customer-Communication-Management.pdf",
			isExternal: true,
			target: "_blank",
			width: "8.1%",
			height: "18.3%",
			left: "29%",
			top: "32.9%",
		},
		{
			label: "Spark Matrix™ for Customer Journey Mapping, 2021",
			href: "https://resources.quadient.com/m/32ca21103c463e13/original/SPARK-Matrix-Customer-Journey-Mapping.pdf",
			isExternal: true,
			target: "_blank",
			width: "8.3%",
			height: "22.3%",
			left: "37.4%",
			top: "33.9%",
		},
		{
			label: "Gartner Market Guide for CCM, 2021",
			href: "https://www.gartner.com/doc/reprints?id=1-26I09A4Q&ct=210614&st=sb",
			isExternal: true,
			target: "_blank",
			width: "7.6%",
			height: "22.7%",
			left: "46.1%",
			top: "33.9%",
		},
		{
			label: "Forrester Report: Enterprises Need a New Architecture to Manage Communications",
			href: "https://reprints2.forrester.com/#/assets/2/959/RES121370/report",
			isExternal: true,
			target: "_blank",
			width: "7.4%",
			height: "23.2%",
			left: "54.5%",
			top: "33.6%",
		},
		{
			label: "2021 Aspire Leaderboard for Customer Communications Management",
			href: "https://www.aspireleaderboard.com/best-customer-communications-management-software",
			isExternal: true,
			target: "_blank",
			width: "8.3%",
			height: "19.7%",
			left: "62.6%",
			top: "32.9%",
		},
		{
			label: "Infographics",
			width: "9.8%",
			height: "17.2%",
			left: "8.4%",
			top: "70.7%",
			onClick: () => { document.getElementById("quadient2021-pdfs").click() }

		},
		{
			label: "Moments that Matter: Critical Touchpoints that Make or Break The Customer Experience",
			href: "https://resources.quadient.com/m/366a56cb2eb1604f/original/eBook-Moments-that-Matter-Critical-Touchpoints-that-Make-or-Break-the-Customer-Experience.pdf",
			isExternal: true,
			target: "_blank",
			width: "13.8%",
			height: "16.9%",
			left: "25.5%",
			top: "51.3%",
		},
		{
			label: "The State of CX",
			href: "https://resources.quadient.com/m/2de9841d3a157068/original/State-of-CX-eBook.pdf",
			isExternal: true,
			target: "_blank",
			width: "19.1%",
			height: "20.9%",
			left: "40.4%",
			top: "59.9%",
		},
		{
			label: "Cxictionary",
			href: "https://resources.quadient.com/m/435530a835de4367/original/The-CXictionary.pdf",
			isExternal: true,
			target: "_blank",
			width: "13.7%",
			height: "16%",
			left: "60.1%",
			top: "51.8%",
		},
		{
			label: "Inspire Evolve: Cloud Communications Built for the Future",
			width: "9.3%",
			height: "11.6%",
			left: "74.1%",
			top: "27.8%",
			modal: <VimeoFrame wrapperStyle={{ backgroundColor: "#7536f0" }} vidId="644064256?h=788766150c&autoplay=1" />
		},
		{
			label: "Top take-aways for Quadient customers from the 2021 Aspire Leaderboard",
			width: "11.8%",
			height: "13.5%",
			left: "83.9%",
			top: "25.1%",
			modal: <VimeoFrame wrapperStyle={{ backgroundColor: "#7536f0" }} vidId="644047301?h=94f6131e9f&autoplay=1" />
		},
		{
			label: "Mind the Gap: Avoiding Common Mistakes when Interacting with Customers Webinar on Demand",
			width: "10.3%",
			height: "11.1%",
			left: "78.7%",
			top: "40.4%",
			modal: <VimeoFrame wrapperStyle={{ backgroundColor: "#7536f0" }} vidId="644053499?h=7d9c6d3629&autoplay=1" />
		},
		{
			label: "Research Reports",
			width: "10.4%",
			height: "18.5%",
			left: "81%",
			top: "69.2%",
			onClick: () => { document.getElementById("quadient2021-pdfs-right").click() }

		},
	],
	name: "resource-hub",
}
